'use strict'

import { httpGet } from '../../../../services/api/AmplifyApi'
import { restApiKey } from '../../../../_constants/Code'
import { PathInfoList } from '../../../../_constants/PathInfoList'
import { getMessage } from '../../../../common/utils/MessageUtils'
import { mapDataUpdateTaskInfoToViewModel } from './helpers'
import { DataUpdateTaskInfoApiBodySchema } from './types'

/**
 * IF02098 データ更新タスク情報取得 GET /{corporationNumber}/get_data_update_task_info
 *
 * @param {string} corporationNumber - 法人番号
 * @returns {Promise<{
 *   fiscalPeriodOptions: string[]
 *   fiscalPeriodGroups: { fiscalPeriod: string; tasks: object[] }[]
 * }>}
 */
export async function fetchDataUpdateTaskInfo(corporationNumber) {
  const init = { headers: {} }
  const response = await httpGet(
    restApiKey.CHROFY_REST_API,
    PathInfoList.Resource.getDataUpdateTaskInfo(corporationNumber),
    init
  )
  const body = response?.body ?? response
  if (!body || typeof body !== 'object') {
    throw new Error(getMessage('E010009', 'データ更新タスク情報'))
  }
  const parsed = DataUpdateTaskInfoApiBodySchema.safeParse(body)
  if (!parsed.success) {
    throw new Error(getMessage('E010009', 'データ更新タスク情報'))
  }
  return mapDataUpdateTaskInfoToViewModel(parsed.data)
}
